"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebCryptoConfig = void 0;
if (globalThis.TextEncoder === undefined || globalThis.TextDecoder === undefined) {
    require('fast-text-encoding');
}
class WebCryptoConfig {
    static getSubtle() {
        var _a, _b;
        if (((_a = globalThis) === null || _a === void 0 ? void 0 : _a.webCryptoOverrideImpl) !== undefined) {
            return (_b = globalThis) === null || _b === void 0 ? void 0 : _b.webCryptoOverrideImpl;
        }
        else {
            return globalThis.crypto.subtle;
        }
    }
}
exports.WebCryptoConfig = WebCryptoConfig;
//# sourceMappingURL=WebCryptoConfig.js.map